import React, { useEffect, useRef, useState } from "react";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import { staffAttendance, latest_employee_id } from "../../../services/staff.services";
import { list, add, detail, deleteDriver, edit } from "../../../services/driver.services";
import { LOADER_TIMEOUT_TIME, PHONE_NO_LENGTH, SORT_A, SORT_D, SWAL_SETTINGS } from "../../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import { getDayDiff, globalLoader, handleOffcanvasScroll, handleServerValidations, TrimText, useDebouncing } from "../../../../../utils/commonfunction";
import CustomError from "../../../../../utils/customError";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import RecordNotFound from "../../../shared/recordNotFound";
import PhoneInput from "../../../../../utils/PhoneInput";
import { Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import TableLoader from "../../../../../utils/TableLoader";
import CustomPagination from "../../../../admin/common/custompagination";


export default function Driver() {
  const navigate = useNavigate()
  const location = useLocation();
  const params = useParams();
  const { t } = useTranslation();
  const [List, setList] = useState([]);
  const { driverValidationSchema, editDriverValidationSchema } = useValidationSchemas();
  const [refreshList, setRefreshList] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
  const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [loader, setLoader] = useState(true);
  const [staffDetail, setStaffDetail] = useState({});
  const [attendance, setAttendance] = useState([]);
  const [attendanceLoader, setAttendanceLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [itemPerPage] = useState(10);
  const [employeeId, setEmployeeId] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [attendancePage, setAttendancePage] = useState(1);
  const [attendanceOffset, setAttendanceOffset] = useState(0);
  const [attendanceTotalRecords, setAttendanceTotalRecords] = useState(0);

  // State for search input and select dropdown
  const [searchValue, setSearchValue] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [sortConfig, setSortConfig] = useState({ column: 'createdAt', order: SORT_D });
  const [sortHistoryConfig, setSortHistoryConfig] = useState({ column: 'date', order: SORT_D });
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = Number(value);
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const prepareGlobalSearch = (value) => {
    setPrevGlobalSearch(globalSearch)
    setGlobalSearch(value);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch);

  const handleFilterStatusChange = (e) => {
    if (e.target.value) {
      prepareSearch("is_assigned", e.target.value);
    } else {
      prepareSearch("is_assigned", "");
    }
  };




  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    searchDebounce(value);
  };

  // Handle select dropdown change
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedStatus(value);
    handleFilterStatusChange(e);
  };

  const handleSort = (key) => {
    let direction = SORT_A;
    if (sortConfig.column === key && sortConfig.order === SORT_A) {
      direction = SORT_D;
    }
    setSortConfig({ column: key, order: direction });
  };

  useEffect(() => {

    if (!location.pathname.includes("staff-attendance") || !selectedEmployeeId) {
      setLoader(true);
      const formData = new FormData();
      if (Object.keys(search).length) {
        formData.append("search", JSON.stringify(search));
      }
      formData.append("global_search", globalSearch);
      // Determine the page number
      let page = params.page;
      if (globalSearch) {
        if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
          page = 1; // Reset to the first page if globalSearch changes
        }
        setPage(page);
      }
      formData.append("page", page);
      formData.append("per_page", itemPerPage);
      if (sortConfig) {
        formData.append("sort", JSON.stringify(sortConfig));
      }
      list(formData)
        .then((data) => {
          if (data && data.data) {
            setList(data.data.list || []);
            setPage(data.data.page);
            navigate(`/restaurant/settings/driver/${data.data.page}`);
            setOffsetPage(data.data.offset);
            setTotalRecords(data.data.total_records || 0);
          } else {
            setList([]);
            setOffsetPage(0);
            setTotalRecords(0);
          }
          setPrevGlobalSearch(globalSearch);
          setTimeout(() => {
            setLoader(false);
          }, LOADER_TIMEOUT_TIME);
        })
        .catch((error) => {
          console.log("error ====> ", error);
          setTimeout(() => {
            setLoader(false);
          }, LOADER_TIMEOUT_TIME);
        });
    }
    else {
      setAttendanceLoader(true);
      const formData = new FormData();
      let page = params.page;
      setAttendancePage(page);
      formData.append("page", page);
      formData.append("per_page", itemPerPage);
      staffAttendance(selectedEmployeeId, formData)
        .then((response) => {
          setTimeout(() => { setAttendanceLoader(false) }, LOADER_TIMEOUT_TIME);
          setAttendance(response?.data?.list);
          setAttendancePage(response?.data?.page);
          setAttendanceOffset(response.data.offset);
          setAttendanceTotalRecords(response.data.total_records || 0);
          navigate(`/restaurant/settings/driver/${response.data.page}`);
        })
        .catch((err) => {
          setTimeout(() => { setAttendanceLoader(false) }, LOADER_TIMEOUT_TIME);
          console.log(err);
        });
    }
  }, [search, refreshList, globalSearch, params.page, sortConfig]);


  const getStaffDetail = (item) => {
    detail({ o_id: item._id })
      .then((response) => {
        editForm.setValues({
          o_id: response?.data?._id || "",
          name: response?.data?.name || "",
          email: response?.data?.email || "",
          phone_number: response?.data?.phone_number || "",
        });
        setStaffDetail(response?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };




  const addForm = useFormik({
    validateOnBlur: false,
    enableReinitialize: true,
    initialValues: {
      name: "",
      email: "",
      phone_number: "",
    },
    validationSchema: driverValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phone_number", values.phone_number);
      setAddSubmissionLoader(true);
      add(formData)
        .then((response) => {
          setAddSubmissionLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            setOpenWithHeader(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error updating profile", error);
        });
      console.log(values);
    },
  });

  const editForm = useFormik({
    initialValues: {
      o_id: "",
      name: "",
      email: "",
      phone_number: "",
    },
    validationSchema: driverValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      setEditSubmissionLoader(true);
      const payload = {
        o_id: staffDetail._id,
        name: values.name,
        email: values.email,
        phone_number: values.phone_number
      };
      edit(payload)
        .then((response) => {
          setEditSubmissionLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            setOpenWithHeaderEdit(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setEditSubmissionLoader(false);
          console.error("Error updating profile", error);
        });
      console.log(values);
    },
  });


  const deleteRecord = (item) => {
    Swal.fire({
      title: t("restaurant.header.msg_are_you_sure"),
      text: t("restaurant.staff.btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("restaurant.button.btn_delete"),
      cancelButtonText: t("restaurant.button.btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        deleteDriver({ o_id: item._id })
          .then((response) => {
            globalLoader(false);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setRefreshList(!refreshList);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            globalLoader(false);
            console.log("deleteError");
          });
      } else {
        // setSortableCategories(List);
      }
    });
  };




  const handleHistorySort = (key, item = null) => {
    let direction = SORT_A;
    if (sortHistoryConfig.column === key && sortHistoryConfig.order === SORT_A) {
      direction = SORT_D;
    }
    setSortHistoryConfig({ column: key, order: direction });
  };

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">{t("restaurant.driver.drivers")}</h4>
        </div>
        <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
          <div className="search-box">
            <input
              type="text"
              value={searchValue} // Bind state value
              className="form-control search-input"
              placeholder={t("restaurant.driver.input_placeholder_search")}
              onChange={handleSearchChange} // Use onChange instead of onInput for better performance
            />
          </div>
          <div className="card-head-group d-flex align-items-center gap-2">
           
            <button
              className="btn btn-primary"
              onClick={() => {
                setOpenWithHeader(true);
              }}
            >
              {t("restaurant.staff.label_create_new")}
            </button>
          </div>
        </div>

        <div className="dashboard-content-wraper">
          <div className="category-list-wrap">
            {loader ? (
              <div className="w-100">
                <Skeleton className="mb-2" height={50} count={5} />
              </div>
            ) : List?.length ? (
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>{t("restaurant.driver.s_no")}</th>
                          <th>{t("restaurant.driver.name")}
                            <span style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>

                              <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'name' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '5px' }}></i>
                              <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'name' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '-8px' }} />
                            </span>
                          </th>
                          <th>{t("restaurant.driver.email")}
                            <span style={{ cursor: 'pointer' }} onClick={() => handleSort('email')}>

                              <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'email' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '5px' }}></i>
                              <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'email' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '-8px' }} />
                            </span>
                          </th>
                          <th>{t("restaurant.driver.contact_no")}
                            <span style={{ cursor: 'pointer' }} onClick={() => handleSort('phone_number')}>

                              <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'phone_number' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '5px' }}></i>
                              <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'phone_number' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '-8px' }} />
                            </span></th>
                          {/* <th>{t("restaurant.driver.assigned")}</th> */}
                          <th style={{ width: "150px" }}>{t("restaurant.staff.label_action")}</th>

                        </tr>

                      </thead>
                      <tbody>
                        {List.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{offset + index + 1}</td>
                              <td>{TrimText(item?.name, 30)}</td>
                              <td>{item?.email ? item?.email : '-'}</td>
                              <td>{item?.phone_number}</td>
                              {/* <td>
                                <div className="mai-card-right">
                                  <div className="form-check form-switch">
                                   {item.is_assigned ? 'True' : 'False'}
                                  </div>
                                </div>
                              </td> */}

                              <td className="d-flex">
                                <div className="dropdown ms-2">
                                  <button className="btn btn-icon dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="ti ti-dots-vertical"></i>
                                  </button>
                                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">

                                    <li>
                                      <a className="dropdown-item cp"
                                        onClick={() => {
                                          getStaffDetail(item);
                                          setOpenWithHeaderEdit(true);
                                        }}
                                      >
                                        <i className="ti ti-edit"></i>
                                        {t("restaurant.button.btn_edit")}
                                      </a>
                                    </li>
                                    <li>
                                      <a className="dropdown-item cp"
                                        onClick={() => {
                                          deleteRecord(item);
                                        }}
                                      >
                                        <i className="ti ti-trash"></i>
                                        {t("restaurant.button.btn_delete")}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="table-status-info d-flex justify-content-between align-items-center">
                    <span>{t("restaurant.staff.label_showing")} {offset + List.length} of {totalRecords} {t("restaurant.staff.label_entries")}</span>
                    <nav aria-label="Page navigation example" title={page}>
                      {totalRecords && totalRecords > 0 ?
                        <CustomPagination
                          datalength={totalRecords}
                          itemperpage={itemPerPage}
                          currentPage={page}
                          custompath="page"
                          setPage={setPage}
                          pageRoute={[{ name: "settings", path: "/restaurant/settings/driver" }]} /> : ""
                      }
                    </nav>
                  </div>
                </div>
              </div>
            ) : (
              <RecordNotFound heading="restaurant.staff.no_staff_found" />
            )}
          </div>
        </div>
        <div>
          {/* <button className='btn btn-success' data-bs-toggle="offcanvas" data-bs-target="#view-staff">view staff details</button>
                    <button className='btn btn-danger ms-2' data-bs-toggle="modal" data-bs-target="#shift-history">view staff details</button> */}
        </div>
      </div>

      {/* add item modal  */}
      <Drawer open={openWithHeader}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("restaurant.staff.create_driver")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeader(false);
                addForm.resetForm();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editNewEmail", "rsuite");
          }}
        >
          <form onSubmit={addForm.handleSubmit} noValidate={true}>

            {/* First Name */}
            <div className="mb-3">
              <label className="form-label">
                {t("restaurant.driver.name")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("restaurant.driver.placeholder_name")}
                name="name"
                value={addForm?.values?.name}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError name="name" form={addForm} className="text-danger" />
            </div>

            {/* Email */}
            <div className="mb-3">
              <label className="form-label">
                {t("restaurant.staff.label_email")}
              </label>
              <input
                type="email"
                className="form-control"
                placeholder={t("restaurant.staff.placeholder_email_address")}
                name="email"
                value={addForm?.values?.email}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError name="email" form={addForm} className="text-danger" />
            </div>

            {/* Phone Number */}
            <div className="mb-3">
              <label className="form-label">
                Contact Number
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={addForm?.values?.phone_number}
                name={"phone_number"}
                onChange={addForm.handleChange}
                placeholder={t("restaurant.staff.placeholder_contact_number")}
                onBlur={addForm.handleBlur}
              />
              <CustomError name="phone_number" form={addForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
            </div>

            {/* Submit Button */}
            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                Create
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>


      <Drawer open={openWithHeaderEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("restaurant.staff.heading_edit_driver")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeaderEdit(false);
                editForm.resetForm();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editEmail", "rsuite");
          }}
        >
          <form onSubmit={editForm.handleSubmit} noValidate={true}>

            {/* Name */}
            <div className="mb-3">
              <label className="form-label">
                {t("restaurant.driver.name")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("restaurant.driver.placeholder_name")}
                name="name"
                value={editForm?.values?.name}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError name="name" form={editForm} className="text-danger" />
            </div>

            {/* Email */}
            <div className="mb-3">
              <label className="form-label">
                {t("restaurant.staff.label_email")}
              </label>
              <input
                type="email"
                className="form-control"
                placeholder={t("restaurant.staff.placeholder_email_address")}
                name="email"
                value={editForm?.values?.email}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError name="email" form={editForm} className="text-danger" />
            </div>

            {/* Phone Number */}

            <div className="mb-3">
              <label htmlFor="phone_number" className="form-label">
                Contact Number
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={editForm?.values?.phone_number}
                name={"phone_number"}
                onChange={(e) => {
                  editForm.setFieldValue("phone_number", e.target.value);
                }}
                onBlur={editForm.handleBlur}
                placeholder={t("restaurant.staff.placeholder_contact_number")}
              />
              <CustomError name="phone_number" form={editForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
            </div>

            {/* Submit Button */}
            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                Update
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>


      <div className="modal fade sort-modal" data-bs-backdrop="static" id="shift-history" tabIndex="-1" aria-labelledby="shift-historyLabel" aria-modal="true" role="dialog">
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                {t('restaurant.staff.shift_history_label')}
              </h1>
              <button type="button" className="btn-close btn-icon" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setEmployeeId(""); navigate(`/restaurant/settings/driver/${page}`); setAttendancePage(1) }}>
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="card">
                {attendance.length > 0 ?

                  (<div className="card-body">
                    <div className="table-responsive">
                      {attendanceLoader ? <TableLoader /> : (<table className="table">
                        <thead>
                          <tr>
                            <th>{t('restaurant.staff.s_no')}</th>
                            <th>{t('restaurant.staff.employee_id')}</th>
                            <th>{t('restaurant.staff.staff_name')}</th>
                            <th>{t('restaurant.staff.input_placeholder_date')}
                              <span style={{ cursor: 'pointer' }} onClick={() => handleHistorySort('date')}>

                                <i className={`ti ti-arrow-narrow-up ${sortHistoryConfig.column === 'date' && sortHistoryConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                  style={{ marginLeft: '5px' }}></i>
                                <i className={`ti ti-arrow-narrow-down ${sortHistoryConfig.column === 'date' && sortHistoryConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                  style={{ marginLeft: '-8px' }} />
                              </span>
                            </th>
                            <th>{t('restaurant.staff.shift_start_time')}
                              <span style={{ cursor: 'pointer' }} onClick={() => handleHistorySort('start_time')}>

                                <i className={`ti ti-arrow-narrow-up ${sortHistoryConfig.column === 'start_time' && sortHistoryConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                  style={{ marginLeft: '5px' }}></i>
                                <i className={`ti ti-arrow-narrow-down ${sortHistoryConfig.column === 'start_time' && sortHistoryConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                  style={{ marginLeft: '-8px' }} />
                              </span>
                            </th>
                            <th>{t('restaurant.staff.shift_break_time')}</th>
                            <th>{t('restaurant.staff.shift_end_time')}

                              <span style={{ cursor: 'pointer' }} onClick={() => handleHistorySort('end_time')}>
                                <i className={`ti ti-arrow-narrow-up ${sortHistoryConfig.column === 'end_time' && sortHistoryConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                  style={{ marginLeft: '5px' }}></i>
                                <i className={`ti ti-arrow-narrow-down ${sortHistoryConfig.column === 'end_time' && sortHistoryConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                  style={{ marginLeft: '-8px' }} />
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {attendance
                            ? attendance.map((item, index) => {
                              return (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>{item?.staff_info[0]?.employee_id}</td>
                                  <td>{item?.staff_info[0]?.name}</td>
                                  <td>{new Date(item?.date).toLocaleDateString("en-US", { weekday: "long", day: "2-digit", month: "2-digit", year: "numeric" })}</td>
                                  <td>{new Date(item?.start_time).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })} </td>
                                  <td>
                                    {(item.break_time_hours && item.break_time_hours !== null ? item.break_time_hours : 0) +
                                      "h " +
                                      (item.break_time_minutes && item.break_time_minutes !== null ? item.break_time_minutes : 0) +
                                      "m"}
                                  </td>

                                  <td>{item?.end_time ? new Date(item?.end_time).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true }) + getDayDiff(item?.start_time, item?.end_time) : t('restaurant.staff.label_not_entered')}
                                  </td>
                                </tr>
                              );
                            })
                            : ""}
                        </tbody>
                      </table>)}

                    </div>

                    <div className="table-status-info d-flex justify-content-between align-items-center">
                      <span>{t("restaurant.staff.label_showing")} {attendanceOffset + attendance.length} of {attendanceTotalRecords} {t("restaurant.staff.label_entries")}</span>
                      <nav aria-label="Page navigation example" title={attendancePage}>
                        {attendanceTotalRecords && attendanceTotalRecords > 0 ?
                          <CustomPagination
                            datalength={attendanceTotalRecords}
                            itemperpage={itemPerPage}
                            currentPage={attendancePage}
                            custompath="page"
                            setPage={setAttendancePage}
                            pageRoute={[{ name: "settings", path: "/restaurant/settings/driver" }]} /> : ""
                        }
                      </nav>
                    </div>
                  </div>) :
                  <RecordNotFound heading="restaurant.staff.lbl_record_not_found" />}

              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
